import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { cn } from '../lib/cn';
/**
 * The handoff's own `Card` — `components/core/Card.jsx` in the design-system bundle, which
 * renders `borderRadius: var(--radius-xl)` (24px), `boxShadow: var(--shadow-sm)` and
 * `border: 1px solid var(--border-subtle)` over `--surface-card`.
 *
 * The border is `--border-subtle` (`--ivory-400`, a warm hairline) and **not** `--border-default`
 * (`--gray-200`, a cool one). The handoff draws `--border-subtle` on every card and
 * `--border-default` on controls — inputs, selects, pills — and this had the control's colour.
 * `console-panel.tsx` made the same correction for the internal console's `Panel`, and
 * `events-page.tsx` writes the correct trio out by hand rather than using this component, which
 * is what a component drifting from its own design looks like from the outside.
 */
export const Card = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('rounded-xl border border-border-subtle bg-card text-card-foreground shadow-sm', className), ...props })));
Card.displayName = 'Card';
export const CardHeader = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex flex-col space-y-1.5 p-6', className), ...props })));
CardHeader.displayName = 'CardHeader';
export const CardTitle = React.forwardRef(({ className, children, ...props }, ref) => (_jsx("h3", { ref: ref, className: cn('text-base font-semibold leading-none tracking-tight', className), ...props, children: children })));
CardTitle.displayName = 'CardTitle';
export const CardDescription = React.forwardRef(({ className, ...props }, ref) => (_jsx("p", { ref: ref, className: cn('text-sm text-muted-foreground', className), ...props })));
CardDescription.displayName = 'CardDescription';
export const CardContent = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('p-6 pt-0', className), ...props })));
CardContent.displayName = 'CardContent';
export const CardFooter = React.forwardRef(({ className, ...props }, ref) => (_jsx("div", { ref: ref, className: cn('flex items-center p-6 pt-0', className), ...props })));
CardFooter.displayName = 'CardFooter';
//# sourceMappingURL=card.js.map